import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ReceiptModal } from '@shared/models/receipt-modal';
import { LinkComponent } from '@vg-constellation/angular-16/link';

import { ReceiptModalService } from '../receipt-modal/receipt-modal.service';

@Component({
  selector: '.app-receipt-row',
  templateUrl: './receipt-row.component.html',
  styleUrls: ['./receipt-row.component.scss'],
  standalone: true,
  imports: [NgClass, LinkComponent],
})
export class ReceiptRowComponent {
  @Input()
  labelText: string = '';

  @Input()
  valueText: string[] = [];

  @Input()
  evidenceIdName: string = '';

  @Input()
  modal: string;

  @Input()
  isLabelBold?: boolean = false;

  @Input()
  isLabelBoldGrey?: boolean = false;

  constructor(private receiptModalService: ReceiptModalService) {}

  get labelBoldClass() {
    const labelClass1 = this.isLabelBold && 'bold-review-label';
    const labelClass2 = this.isLabelBoldGrey && 'bold-review-label-2';
    return labelClass2 || labelClass1 || '';
  }

  modalClicked(modal: ReceiptModal) {
    this.receiptModalService.modalClicked(modal);
  }
}
